import { gql } from '@apollo/client';

export const SALESFORCE_LEADS_PAGE_SIZE = 20;
export const SALESFORCE_ACCOUNTS_PAGE_SIZE = 20;
export const SALESFORCE_EMAIL_TEMPLATES_PAGE_SIZE = 20;

export const CREATE_SALESFORCE_LEAD = gql`
  mutation createSalesforceLead($input: SalesforceLeadInput!)
  @api(name: treatmentMonitor) {
    createSalesforceLead(input: $input) {
      id
    }
  }
`;

export const DELETE_SALESFORCE_LEAD = gql`
  mutation deleteSalesforceLead($id: ID!) @api(name: treatmentMonitor) {
    deleteSalesforceLead(id: $id)
  }
`;

export const UPDATE_SALESFORCE_LEAD = gql`
  mutation updateSalesforceLead($id: ID!, $input: SalesforceLeadInput!)
  @api(name: treatmentMonitor) {
    updateSalesforceLead(id: $id, input: $input) {
      id
    }
  }
`;

export const GET_SALESFORCE_LEAD_BY_ID = gql`
  query getSalesforceLeadById($id: ID!) @api(name: treatmentMonitor) {
    getSalesforceLeadById(id: $id) {
      id
      name
      firstName
      lastName
      salutation
      middleName
      suffix
      street
      city
      postalCode
      country
      mobilePhone
      email
      leadSource
      status
      currencyIsoCode
      leadOwner
      ownerId
      ownerAlias
      isConverted
      convertedDate
      convertedOpportunityId
      createdDate
      createdBy
      lastModifiedDate
      lastModifiedBy
      s3FileObtPictureCount
      campaignPromoCode
      influencerPromoCode
      leadAssignment
      numberOfPhoneCalls
      referralId
      language
      patientMainConcern
      daysSinceWaitingForPictures
      leadIdFormula
      googleAnalyticsCampaignOpp
      googleAnalyticsContentOpp
      tags
      testRecord
      formSubmissionDate
      utmCampaign
      utmContent
      utmMedium
      utmSource
      utmTerm
      age
      weChatId
      whatsAppNumber
      googleAnalyticsMediumOpp
      googleAnalyticsSourceOpp
      googleAnalyticsTermOpp
      opportunitySource
      lineId
      resubmissionCount
      smsSentHkTw
      zaloId
      isAutoConverted
      ageCategory
      sourceUrl
      leadSourceLastTouch
      opportunitySourceLastTouch
      countOfFrontViewS3Files
      countOfLowerViewS3Files
      countOfSideViewS3Files
      countOfUpperViewS3Files
      zenCalBookingStartTime
      weChatConsent
      weChatNumber
      zenCalBookingReceived
      externalReferralId
      employeeReferralId
      phoneNumberIntercom
      zenCalBookingReceivedSource
      zenCalOwner
      guardianPhoneNumber
      guardianEmail
      guardianFullName
      guardianWhatsAppNumber
      haveInformedGuardian
      submittingForTheChild
      obtUserType
      branchCode
    }
  }
`;

export const GET_SALESFORCE_FILES = gql`
  query getSalesforceFiles($filter: SalesforceFileFilter)
  @api(name: treatmentMonitor) {
    getSalesforceFiles(filter: $filter) {
      files {
        id
        fileName
        fileClassification
        fileClassificationType
        user
        downloadUrl
        preAssessmentPictureType
        lastReplacedDate
      }
    }
  }
`;

export const GET_FILES_UPLOAD_URL = gql`
  query getFilesUploadUrl($key: String!) @api(name: treatmentMonitor) {
    getFilesUploadUrl(key: $key) {
      url
      expiresIn
    }
  }
`;

export const UPLOAD_SALESFORCE_FILE = gql`
  mutation uploadSalesforceFile($input: SalesforceFileInput!)
  @api(name: treatmentMonitor) {
    uploadSalesforceFile(input: $input)
  }
`;

export const UPDATE_SALESFORCE_FILE = gql`
  mutation updateSalesforceFile($id: ID!, $input: SalesforceFileInput!)
  @api(name: treatmentMonitor) {
    updateSalesforceFile(id: $id, input: $input) {
      id
      fileName
      fileClassification
      fileClassificationType
      preAssessmentPictureType
      downloadUrl
      lastReplacedDate
      user
    }
  }
`;

export const DELETE_SALESFORCE_FILE = gql`
  mutation deleteSalesforceFile($id: ID!) @api(name: treatmentMonitor) {
    deleteSalesforceFile(id: $id)
  }
`;

export const GET_SALESFORCE_LEADS = gql`
  query getSalesforceLeads($filter: SalesforceLeadFilter)
  @api(name: treatmentMonitor) {
    getSalesforceLeads(filter: $filter) {
      leads {
        id
        name
        firstName
        lastName
        email
        mobilePhone
        country
        leadOwner
        isConverted
        ageCategory
        status
        createdDate
      }
      hasNext
    }
  }
`;

export const UPDATE_SALESFORCE_ACCOUNT = gql`
  mutation updateSalesforceAccount($id: ID!, $input: SalesforceAccountInput!)
  @api(name: treatmentMonitor) {
    updateSalesforceAccount(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_SALESFORCE_ACCOUNT = gql`
  mutation deleteSalesforceAccount($id: ID!) @api(name: treatmentMonitor) {
    deleteSalesforceAccount(id: $id)
  }
`;

export const GET_SALESFORCE_LEAD_HISTORY = gql`
  query getSalesforceLeadHistory($leadId: ID!) @api(name: treatmentMonitor) {
    getSalesforceLeadHistory(leadId: $leadId) {
      createdDate
      field
      fieldLabel
      createdBy
      newValue
      oldValue
    }
  }
`;

export const GET_SALESFORCE_ACCOUNT_HISTORY = gql`
  query getSalesforceAccountHistory($accountId: ID!)
  @api(name: treatmentMonitor) {
    getSalesforceAccountHistory(accountId: $accountId) {
      createdDate
      field
      fieldLabel
      createdBy
      newValue
      oldValue
    }
  }
`;

export const GET_SALESFORCE_ACTIVITIES = gql`
  query getSalesforceActivities($filter: SalesforceActivityFilter)
  @api(name: treatmentMonitor) {
    getSalesforceActivities(filter: $filter) {
      id
      subject
      description
      status
      priority
      activityDate
      startDateTime
      endDateTime
      whoId
      whatId
      ownerId
      ownerName
      activityType
      isClosed
      type
      location
      createdDate
      lastModifiedDate
    }
  }
`;

export const GET_SALESFORCE_ORG_WIDE_EMAIL_ADDRESSES = gql`
  query getSalesforceOrgWideEmailAddresses @api(name: treatmentMonitor) {
    getSalesforceOrgWideEmailAddresses {
      id
      address
      displayName
      isAllowAllProfiles
      isVerified
      purpose
    }
  }
`;

export const GET_SALESFORCE_EMAIL_TEMPLATES = gql`
  query getSalesforceEmailTemplates($filter: SalesforceEmailTemplateFilter)
  @api(name: treatmentMonitor) {
    getSalesforceEmailTemplates(filter: $filter) {
      id
      name
      developerName
      subject
      body
      htmlValue
      templateType
      folderId
      folderName
      isActive
      description
      createdDate
      lastModifiedDate
    }
  }
`;

export const GET_RENDERED_TEMPLATE_BY_ID = gql`
  query getRenderedTemplateById(
    $id: ID!
    $recipientId: ID!
    $relatedRecordId: ID!
  ) @api(name: treatmentMonitor) {
    getRenderedTemplateById(
      id: $id
      recipientId: $recipientId
      relatedRecordId: $relatedRecordId
    ) {
      success
      raw {
        subject
        htmlValue
      }
      rendered {
        subject
        htmlBody
        plainTextBody
      }
      errorCode
      message
    }
  }
`;

export const SEND_SALESFORCE_EMAIL = gql`
  mutation sendSalesforceEmail($input: SalesforceSendEmailInput!)
  @api(name: treatmentMonitor) {
    sendSalesforceEmail(input: $input) {
      success
      message
    }
  }
`;

export const LOG_SALESFORCE_CALL = gql`
  mutation logSalesforceCall($input: SalesforceLogCallInput!)
  @api(name: treatmentMonitor) {
    logSalesforceCall(input: $input) {
      success
      redirectUri
    }
  }
`;

export const UPDATE_SALESFORCE_CALL_NOTES = gql`
  mutation updateSalesforceCallNotes($input: SalesforceUpdateCallNotesInput!)
  @api(name: treatmentMonitor) {
    updateSalesforceCallNotes(input: $input) {
      id
      success
    }
  }
`;

export const GENERATE_SALESFORCE_ACCOUNT_SURVEY_LINK = gql`
  mutation generateSalesforceAccountSurveyLink($accountId: ID!)
  @api(name: treatmentMonitor) {
    generateSalesforceAccountSurveyLink(accountId: $accountId) {
      link
      success
      message
    }
  }
`;

export const CREATE_SALESFORCE_ACCOUNT_RW_BUNDLE = gql`
  mutation createSalesforceAccountRwBundle($accountId: ID!)
  @api(name: treatmentMonitor) {
    createSalesforceAccountRwBundle(accountId: $accountId) {
      success
      message
    }
  }
`;
